export function isSignaturePresent(signature) {
  return Boolean(signature?.dataUrl && String(signature.dataUrl).startsWith('data:image'));
}
